import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { VWVipButton } from '../../models/vipinfo.model';
import { v4 as uuidv4 } from 'uuid';
import {
  VipDefaultButton,
  VipLinkButton,
} from '@3ddv/ngx-sites-builder-lib/lib/workflows/interface/vipinfo/models/vipinfo.model';
@Component({
  selector: 'app-vipinfo-contents',
  templateUrl: './vipinfo-contents.component.html',
  styleUrls: ['./vipinfo-contents.component.scss'],
})
export class VipinfoContentsComponent {
  @Input() vipButtons: VWVipButton[];
  @Output() editButton: EventEmitter<VWVipButton> = new EventEmitter<VWVipButton>();
  @Output() createNewButton: EventEmitter<VWVipButton> = new EventEmitter<VWVipButton>();
  @ViewChild('isLink') isLink!: ElementRef;

  editItem(button: VWVipButton): void {
    this.editButton.emit(button);
  }

  private readonly defaultLinkConfig = {
    buttonTitle: 'Click me',
    url: null,
  };
  private readonly defaultLinkStyles = {
    buttonColor: '#FFFFFF',
    buttonTextColor: '#000000',
    hoverButtonTextColor: '#000000',
    hoverButtonBackgroundColor: '#FFFFFF',
    buttonBorderColor: '#000000',
  };

  private readonly defaultButtonConfig = {
    buttonTitle: 'Click me',
    closeButtonTitle: 'Close',
    popupContent: 'Thi is the popup content',
    popupTitle: 'Popup title',
  };

  private readonly defaultButtonStyles = {
    ...this.defaultLinkStyles,
    popupHeaderColor: '#61ACD9',
    popupTitleColor: '#FFFFFF',
    popupContentColor: '#000000',
    closeButtonHoverTextColor: '#000000',
    closeButtonHoverBackgroundColor: '#FFFFFF',
    closeButtonColor: '#FFFFFF',
    closeButtonTextColor: '#000000',
  };

  private _generateLinkButton(): VipLinkButton {
    const buttonTypes = this.vipButtons.filter(button => button.type === 'link') as VipLinkButton[];
    let styles = buttonTypes[0]?.styles || this.defaultLinkStyles;
    const button: VipLinkButton = {
      type: 'link',
      styles: styles,
      config: this.defaultLinkConfig,
    };
    return button;
  }

  private _generateDefaultButton(): VipDefaultButton {
    const buttonTypes = this.vipButtons.filter(button => button.type === 'button') as VipDefaultButton[];
    let styles = buttonTypes[0]?.styles || this.defaultButtonStyles;
    const button: VipDefaultButton = {
      type: 'button',
      styles: styles,
      config: this.defaultButtonConfig,
    };
    return button;
  }

  onCreateButton(): void {
    // check which type of button the user wants to create
    let button: VWVipButton;
    const isButtonTypeLink = this.isLink.nativeElement.checked;
    // if a button of the same type already exists, copy its styles (not configuration)
    if (isButtonTypeLink) {
      const buttonLink = this._generateLinkButton() as VipLinkButton;
      button = {
        ...buttonLink,
        id: uuidv4(),
      };
    } else {
      const buttonDefault = this._generateDefaultButton() as VipDefaultButton;
      button = {
        ...buttonDefault,
        id: uuidv4(),
      };
    }
    this.createNewButton.emit(button);
  }
}
